import React, { useEffect, useState } from "react";
import { Projects } from "../../Data/Data";
import NikeaHerroImg from "../../assest/Nikea/images/NikeaHerroImg.jpeg";

const BannerProduct = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 950);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="bg-black relative overflow-hidden h-[calc(100vh-56px)] w-full ">
      <img
        src={isLargeScreen ? NikeaHerroImg : NikeaHerroImg}
        alt="K2 invest green Home banner"
        className="opacity-80 inline-block max-w-full w-full h-[120vh] text-center align-middle object-cover"
        style={{
          transform: `translateY(-${scrollY * 0.1}px)`,
          transition: "transform 1s",
        }}
      />
      <div className="absolute flex flex-col justify-end items-start max-w-[600px] pb-24 pt-36 gap-5 z-20 bottom-0 left-4 md:left-24 h-fit text-primary-light">
        <h1 className="font-gilroy uppercase text-4xl md:text-6xl leading-tight mb-0 mt-0 tracking-widest opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s]">
          {Projects[1].label}
        </h1>
        <div className="font-bpg text-xl md:text-2xl font-normal leading-6  ">
          {Projects[1].address}
        </div>
      </div>
    </div>
  );
};

export default BannerProduct;
